import { DataDesc } from './wxDataDesc';
import { WxIBlobDataItem } from './wxIBlobDataItem';

export { DataDesc };
export { WxIBlobDataItem };
